import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {batch, connect, useDispatch, useSelector} from 'react-redux';
import {bindActionCreators} from 'redux';
import {showModalType} from 'stores/actions/typedModalAction';
import {
  handleManualReteachPreReq,
  checkAndLoadManualReteachProcess,
  modalPreparationManualReteachPlateConfirmation,
} from 'stores/business/manualReteachPlateBusiness/manualReteachPlateBusiness';
import {registerCachedAndClearScannedData, resetScannedPlatesState} from 'stores/business/plateRecognitionBusiness';
import {convertRowToAlphabet} from 'stores/business/commonTaskListBusiness';
import {manualReteachErrorHandler} from 'stores/business/errorHandlers/manualReteachErrorHandler';
import {setSelectedWellStyle} from 'stores/actions/reteachPlateAction';
import {clearInstrumentProcess, setInstrumentProcess} from 'stores/business/instrumentStatusBusiness';
import {InstrumentProcessType} from 'constants/instrumentStatusEnum';
import {
  selectIsAllPlatesScanned,
  selectIsPlateEditStateChanged,
  selectIsPlateRecognitionEnabled,
} from 'stores/selectors/plateRecognitionSelectors';
import FormattedHTMLMessage from '../../components/FormattedHTMLMessage';
import PageLayout from '../../components/Layout/PageLayout';
import PlateTypeEditorHeader from './PlateTypeEditorHeader';
import PlateViewInfoDesc from './PlateViewInfoDesc';
import PlateViewInstructionGuide from './PlateViewInstructionGuide';
import PlateViewGuidance from './PlateViewGuidance';
import PlateViewSummaryDesc from './PlateViewSummaryDesc';
import PlateViewSummaryInfo from './PlateViewSummaryInfo';
import PlateViewMotionControl from './PlateViewMotionControl';
import withIntl from '../../lib/withIntl';
import {FastRobotErrorcode, ViewMode, WellCount, PlateType, Feedback, ModalType} from '../../constants/dataEnum';
import {showLoading, hideLoading, showSnackbar} from '../../stores/actions/appStateAction';
import {showModal, hideModal} from '../../stores/actions/modalStateAction';
import {
  setCurrentWizardView,
  decrementCurrentWizardView,
  setAllowedToNext,
  setProcessedStep,
  setWellNumber,
  setWellBottomProfile,
  setWellShape,
  setPlateName,
  setPartNumber,
  setVendor,
  setNotes,
  setHeight,
  setDepth,
  setWidth,
  setLength,
  setColumnOrigin,
  setRowOrigin,
  setColumnPitch,
  setRowPitch,
  setCapacity,
  setWorkingVolume,
  setLastProcessedId,
  setPlateType,
  setColPitchAssaySample,
  setTroughDepth,
  setPlateTypeEditorEjectTray,
  setPlateTypeEditorEditMode,
  setWellLabel,
} from '../../stores/actions/plateTypeEditorStateAction';
import {fastCommonActuatorAPIErrorHandler} from '../../stores/business/errorHandlerBusiness';
import {
  checkManualPlateDefinitionLabware,
  ejectTray,
  safeMoveVerticalCarrier,
} from '../../stores/business/instrumentBusiness';
import {
  calculateWellCapacityAndWorkingVolume,
  converPlateTypeEditorStateToJSON,
  exitPlateTypeEditor,
  generateRowColTipCount,
  handleClickBack,
  handleClickNext,
  handleResetProbePosition,
  isPlateEditorUpdated,
  proceedMeasurement,
  showCleanupDialog,
} from '../../stores/business/plateTypeEditorBusiness';
import {saveState} from '../../stores/business/stateBusiness';
import {isLabwareNameAlreadyExist} from '../../stores/business/labwareBusinessAction';
import {updateLabwareDefinition, refreshLabwareDefinitions} from '../../stores/business/labwareDatabaseBusiness';
import './PlateTypeEditorContainer.scss';
import '../TrayCalibration/TrayCalibrationContainer.scss';
import Stepper from '../../components/Stepper';
import {findKeyByValue} from '../../lib/objectHelper';
import {WellLabel, defaultPlatesIdList} from './PlateTypeEditorEnum';
import {removeUpdatedPlateFromReteachPlateState} from '../../stores/business/reteachPlateBusiness';
import ModalPreparationManualPlateTypeEditor from './ManualPlateTypeEditor/ModalPreparationManualPlateTypeEditor';
import ManualPlateTypeEditor from './ManualPlateTypeEditor/ManualPlateTypeEditor';
import PlateRecognition from './PlateRecognition/PlateRecognition';

function PlateTypeEditorContainer({
  appState,
  sessionState,
  stateBusinessSaveState,
  plateTypeEditorState,
  manualReteachPlate,
  onShowLoading,
  onHideLoading,
  onShowModal,
  onHideModal,
  onFastCommonActuatorAPIErrorHandler,
  plateTypeEditorBusinessResetProbePosition,
  plateTypeEditorBusinessHandleClickBack,
  plateTypeEditorBusinessHandleClickNext,
  plateTypeEditorBusinessShowCleanupDialog,
  plateTypeEditorBusinessExitPlateTypeEditor,
  plateTypeEditorBusinessCalculateWellCapacityAndWorkingVolume,
  plateTypeEditorConvertPlateTypeEditorStateToJSON,
  plateTypeEditorStateActionSetPlateTypeEditorEjectTray,
  plateTypeEditorStateActionSetPlateTypeEditorEditMode,
  onDecrementCurrentWizardView,
  onSetProcessedStep,
  onSetCapacity,
  onSetWorkingVolume,
  onSetAllowedToNext,
  onSetCurrentWizardView,
  onSetWellNumber,
  onSetWellLabel,
  onSetWellBottomProfile,
  onSetWellShape,
  onSetPlateName,
  onSetTroughDepth,
  onSetColPitchAssaySample,
  onSetPlateType,
  onSetPartNumber,
  onSetVendor,
  onSetNotes,
  onSetHeight,
  onSetDepth,
  onSetWidth,
  onSetLength,
  onSetColumnOrigin,
  onSetRowOrigin,
  onSetColumnPitch,
  onSetRowPitch,
  onSetLastProcessedId,
  instrumentBusinessEjectTray,
  instrumentBusinessSafeMoveVerticalCarrier,
  labwareBusinessIsLabwareNameAlreadyExist,
  labwareDatabaseBusinessUpdateLabwareDefinition,
  labwareDatabaseBusinessRefreshLabwareDefinitions,
  intl,
  labwareConfig,
  plateTypeEditorProceedMeasurement,
  removeUpdatedPlateFromReteachPlateList,
  onShowSnackbar,
}) {
  // const [editModePlateProperties, plateTypeEditorStateActionSetPlateTypeEditorEditMode] = useState(false);
  const {isManualReteachPage} = appState;
  const {username} = sessionState.user;
  console.log(username);
  const [isError, setIsError] = useState(false);
  const [ModalPreparationManualPlateShown, setModalPreparationManualPlateShown] = useState(false);
  const dispatch = useDispatch();
  const {isMoveMotionControl, selectedWellStyle} = manualReteachPlate;
  const isPlateRecognitionEnabled = useSelector(selectIsPlateRecognitionEnabled);
  const isAllPlatesScanned = useSelector(selectIsAllPlatesScanned);
  const isPlateEditStateChanged = useSelector(selectIsPlateEditStateChanged);

  useEffect(() => {
    dispatch(checkAndLoadManualReteachProcess());
  }, [dispatch]);

  useEffect(() => {
    const {processedStep} = plateTypeEditorState;

    if (processedStep > 0) {
      plateTypeEditorStateActionSetPlateTypeEditorEjectTray(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plateTypeEditorState.processedStep]);

  const {id} = plateTypeEditorState;
  const isEdit = id !== null;
  const isEditAllowed = !defaultPlatesIdList.includes(id);

  const getWellNumberImageName = () => {
    const {wellLabel: wellLabelState, wellNumber} = plateTypeEditorState || {};
    let wellLabel = wellLabelState;

    if (!wellLabel) {
      const wellKey = findKeyByValue(WellCount, (el) => el === wellNumber);
      wellLabel = WellLabel[wellKey];
    }

    return wellLabel && wellLabel?.includes('.') ? wellLabel.replace('.', '_') : wellLabel;
  };

  const doEjectTray = async () => {
    onShowLoading(
      intl.formatMessage({
        id: 'plateTypeEditorContainer.ejectingTray.loading',
      }),
    );

    const response = await instrumentBusinessEjectTray();

    onHideLoading();

    if (response !== FastRobotErrorcode.NoError) {
      onFastCommonActuatorAPIErrorHandler(response);

      return null;
    }

    return true;
  };

  async function onCancel(isCancelReteachPlate = false) {
    dispatch(resetScannedPlatesState(isEdit));

    if (isEdit && !isCancelReteachPlate) {
      plateTypeEditorBusinessExitPlateTypeEditor();

      return;
    }

    onShowLoading(
      intl.formatMessage({
        id: 'plateTypeEditorContainer.processing.loading',
      }),
    );

    instrumentBusinessSafeMoveVerticalCarrier(0).then((response) => {
      if (response.result !== FastRobotErrorcode.NoError) {
        onFastCommonActuatorAPIErrorHandler(response.result);
      }
    });

    plateTypeEditorBusinessShowCleanupDialog(true);
  }

  function handleClickCancel(isCancelReteachPlate = false) {
    if (isManualReteachPage) {
      dispatch(showModalType(ModalType.RETURN_TIPS_CONFIRMATION, {saveChanges: false, closeButtonClick: true}));
      return;
    }
    const isLabwareDefinitionUpdated = dispatch(isPlateEditorUpdated());
    if (!isLabwareDefinitionUpdated && !isCancelReteachPlate) {
      onCancel(isCancelReteachPlate);
      return;
    }

    const titleText = intl.formatMessage({
      id: isEdit
        ? 'plateTypeEditorContainer.cancelEditPlateTypeEditor.title'
        : 'plateTypeEditorContainer.cancelPlateTypeEditor.title',
    });

    // show warning
    const warningText = (
      <div id="discard-protocol-text">
        <FormattedHTMLMessage
          id={
            isEdit
              ? 'plateTypeEditorContainer.cancelEditPlateTypeEditor.text'
              : 'plateTypeEditorContainer.cancelPlateTypeEditor.text'
          }
        />
      </div>
    );

    onShowModal(
      titleText,
      warningText,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            onHideModal();
            onCancel(isCancelReteachPlate);
          },
          text: intl.formatMessage({
            id: isEdit
              ? 'plateTypeEditorContainer.cancelEditPlateTypeEditor.firstButton'
              : 'plateTypeEditorContainer.cancelPlateTypeEditor.firstButton',
          }),
        },
        {
          className: 'btn-lg',
          style: 'secondary',
          handlerClick: () => {
            onHideModal();
          },
          text: intl.formatMessage({
            id: isEdit
              ? 'plateTypeEditorContainer.cancelEditPlateTypeEditor.secondButton'
              : 'plateTypeEditorContainer.cancelPlateTypeEditor.secondButton',
          }),
        },
      ],
      () => onHideModal(),
      '',
      true,
    );
  }

  async function handleClickEjectTrayButton() {
    plateTypeEditorStateActionSetPlateTypeEditorEjectTray(true);
    onSetProcessedStep(0);
    onSetHeight(0);
    onSetDepth(0);
    onSetColumnOrigin(0);
    onSetRowOrigin(0);
    onSetWidth(0);
    onSetLength(0);
    stateBusinessSaveState();

    await doEjectTray();

    onHideLoading();
  }

  const handleEditSaveChanges = () => {
    if (isPlateRecognitionEnabled && currentWizardView === 3) {
      dispatch(registerCachedAndClearScannedData(id, isEdit));
    }

    const convertedState = plateTypeEditorConvertPlateTypeEditorStateToJSON();
    // TODO Manual Reteach Plate
    try {
      // save labware definition
      labwareDatabaseBusinessUpdateLabwareDefinition(convertedState).then(() => {
        const {prevViewMode} = appState;

        removeUpdatedPlateFromReteachPlateList(convertedState.ID);
        if (prevViewMode === ViewMode.RETEACH_PLATE) {
          onShowSnackbar(
            Feedback.SUCCESS,
            intl.formatMessage({id: 'plateTypeEditorContainer.reteachPlate.notification.success'}),
          );
        }
        // hide loading
        onHideLoading();
        plateTypeEditorBusinessExitPlateTypeEditor();

        if (prevViewMode === ViewMode.LABWARE_MANAGER || prevViewMode === ViewMode.RETEACH_PLATE) {
          onSetLastProcessedId({id, isEdit: true});
        }

        // get all labware list from back end
        labwareDatabaseBusinessRefreshLabwareDefinitions();
      });
    } catch (error) {
      onHideLoading();
      console.log('fail to save labware ', error);
    }
  };

  function showDiscardChangeModal(targetStep = 0) {
    const warningText = (
      <div id="discard-protocol-text">
        <FormattedHTMLMessage id="plateTypeEditorContainer.discardChangeModal.text" />
      </div>
    );
    onShowModal(
      intl.formatMessage({id: 'plateTypeEditorContainer.discardChangeModal.title'}),
      warningText,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            // decrement step
            if (targetStep) {
              onSetCurrentWizardView(targetStep);
            } else {
              onDecrementCurrentWizardView();
            }

            // save state
            stateBusinessSaveState();
            plateTypeEditorStateActionSetPlateTypeEditorEditMode(false);
            onHideModal();
          },
          text: intl.formatMessage({
            id: 'plateTypeEditorContainer.discardChangeModal.firstButton',
          }),
        },
        {
          className: 'btn-lg',
          style: 'secondary',
          handlerClick: () => {
            onHideModal();
          },
          text: intl.formatMessage({
            id: 'plateTypeEditorContainer.discardChangeModal.secondButton',
          }),
        },
      ],
      () => onHideModal(),
      '',
      true,
    );
  }

  function handleEditPlateProperties(platePorperties) {
    const {plateType} = plateTypeEditorState;

    onSetColumnOrigin(parseFloat(platePorperties.columnOrigin));
    onSetColumnPitch(parseFloat(platePorperties.columnPitch));
    onSetDepth(parseFloat(platePorperties.depth));
    onSetHeight(parseFloat(platePorperties.height));
    onSetLength(parseFloat(platePorperties.length));
    onSetRowOrigin(parseFloat(platePorperties.rowOrigin));
    onSetRowPitch(parseFloat(platePorperties.rowPitch));
    onSetWidth(parseFloat(platePorperties.width));
    if (plateType === PlateType.IFC) {
      onSetTroughDepth(platePorperties.troughDepth);
      onSetColPitchAssaySample(platePorperties.colPitchAssaySample);
    }

    stateBusinessSaveState();
  }

  function createLeftPanel(currentWizardView) {
    const {plateName, wellNumber, wellBottomProfile, wellShape, workingVolume, capacity, wellLabel, plateType} =
      plateTypeEditorState;

    const summaryPanel = (
      <div
        className="left-panel"
        style={{
          width: '30vw',
          borderRight: 'none',
          height: `calc(100vh - ${isEdit ? '64' : '136'}px)`,
        }}
      >
        <PlateViewSummaryDesc
          plateTypeEditorState={plateTypeEditorState}
          plateName={plateName}
          wellNumber={wellNumber}
          wellBottomProfile={wellBottomProfile}
          wellShape={wellShape}
          capacity={capacity}
          workingVolume={workingVolume}
          onSetCapacity={onSetCapacity}
          onSetWorkingVolume={onSetWorkingVolume}
          onSetAllowedToNext={onSetAllowedToNext}
          onSaveState={stateBusinessSaveState}
          onSetPlateName={onSetPlateName}
          isEdit={isEdit}
          maxCharacters={labwareConfig.nameMaxLength}
          labwareBusinessIsLabwareNameAlreadyExist={labwareBusinessIsLabwareNameAlreadyExist}
          isEditAllowed={isEditAllowed}
        />
      </div>
    );

    const plateRecognitionPanel = (
      <div className="left-panel" style={{width: '25%', height: `calc(100vh - ${isEdit ? '64' : '136'}px)`}}>
        <PlateViewInstructionGuide
          title={intl.formatMessage({id: 'plateTypeEditorContainer.aboutPlateRecognition.title'})}
          titleDesc={intl.formatMessage({
            id: 'plateTypeEditorContainer.aboutPlateRecognition.desc',
          })}
          Steps={[
            intl.formatMessage({id: 'plateTypeEditorContainer.aboutPlateRecognition.step1'}),
            intl.formatMessage({id: 'plateTypeEditorContainer.aboutPlateRecognition.step2'}),
            intl.formatMessage({id: 'plateTypeEditorContainer.aboutPlateRecognition.step3'}),
            intl.formatMessage({id: 'plateTypeEditorContainer.aboutPlateRecognition.step4'}),
          ]}
        />
      </div>
    );

    let leftPanel = null;

    switch (currentWizardView) {
      case 2: {
        leftPanel = (
          <div className="left-panel" style={{width: '25%', height: `calc(100vh - ${isEdit ? '64' : '136'}px)`}}>
            <PlateViewInstructionGuide
              title="Well Measurement"
              titleDesc="Follow the instruction below to measure the well measurement detail."
              Steps={[
                intl.formatMessage(
                  {id: 'plateTypeEditorContainer.wellMeasurementInstruction.step1'},
                  {
                    wellNumber: plateType === PlateType.SPEAR_BIO ? 'A10' : 'A1',
                  },
                ),
                wellLabel === WellLabel.WELL_IFC_96_96
                  ? intl.formatMessage({id: 'plateTypeEditorContainer.wellMeasurementInstruction.step2.IFC-9696'})
                  : intl.formatMessage({id: 'plateTypeEditorContainer.wellMeasurementInstruction.step2'}),
                intl.formatMessage({id: 'plateTypeEditorContainer.wellMeasurementInstruction.step3'}),
              ]}
            />
          </div>
        );
        break;
      }
      case 3: {
        if (isPlateRecognitionEnabled) {
          leftPanel = plateRecognitionPanel;
        } else {
          leftPanel = summaryPanel;
        }
        break;
      }
      case 4:
        leftPanel = summaryPanel;
        break;
      default:
        leftPanel = null;
    }

    return leftPanel;
  }

  function createCenterPanel(currentWizardView) {
    const {wellShape, wellBottomProfile, wellLabel} = plateTypeEditorState;
    let centerPanel = null;
    switch (currentWizardView) {
      case 2:
        centerPanel = (
          <div className="center-panel" style={{width: '40%', height: `calc(100vh - ${isEdit ? '64' : '136'}px)`}}>
            <PlateViewGuidance
              wellNumber={getWellNumberImageName()}
              wellBottomProfile={wellLabel === WellLabel.WELL_IFC_96_96 ? getWellNumberImageName() : wellBottomProfile}
              wellShape={wellShape}
              plateType={plateTypeEditorState.plateType}
            />
          </div>
        );
        break;
      default:
        centerPanel = null;
    }
    return centerPanel;
  }

  async function onManualReteachClickHandler() {
    const isReadyToProceed = await dispatch(handleManualReteachPreReq());

    if (!isReadyToProceed) return;

    const {labwareID = id} = plateTypeEditorState;

    dispatch(showLoading(intl.formatMessage({id: 'general.loadingMessage'})));
    const response = await dispatch(checkManualPlateDefinitionLabware(labwareID));
    dispatch(hideLoading());

    if (response === FastRobotErrorcode.NoError) {
      dispatch(setSelectedWellStyle({}));
      dispatch(setInstrumentProcess(InstrumentProcessType.MANUAL_RETEACH_PLATE));
      setModalPreparationManualPlateShown(true);
    } else {
      dispatch(manualReteachErrorHandler(response));
    }
  }

  function createRightPanel(currentWizardView) {
    const {
      wellNumber,
      wellLabel,
      wellBottomProfile,
      wellShape,
      plateName,
      plateType,
      height,
      depth,
      width,
      length,
      columnOrigin,
      rowOrigin,
      columnPitch,
      rowPitch,
      troughDepth,
      colPitchAssaySample,
      editMode,
    } = plateTypeEditorState;

    const plateRecognitionPanel = (
      <div className="right-panel" style={{height: `calc(100vh - ${isEdit ? '64' : '136'}px)`, padding: 0}}>
        <PlateRecognition isEdit={isEdit} />
      </div>
    );

    const summaryPanel = (
      <div className="right-panel" style={{width: '70vw', height: `calc(100vh - ${isEdit ? '64' : '136'}px)`}}>
        <PlateViewSummaryInfo
          wellNumberImageName={getWellNumberImageName()}
          wellNumber={wellNumber}
          wellLabel={wellLabel}
          wellBottomProfile={wellBottomProfile}
          wellShape={wellShape}
          plateName={plateName}
          plateType={plateType}
          height={height}
          depth={depth}
          width={width}
          length={length}
          columnOrigin={columnOrigin}
          rowOrigin={rowOrigin}
          columnPitch={columnPitch}
          rowPitch={rowPitch}
          troughDepth={troughDepth}
          colPitchAssaySample={colPitchAssaySample}
          handleEditPlateProperties={handleEditPlateProperties}
          setEditModePlateProperties={plateTypeEditorStateActionSetPlateTypeEditorEditMode}
          editModePlateProperties={editMode}
          isEdit={isEdit}
          isError={isError}
          setIsError={setIsError}
          isEditAllowed={isEditAllowed}
          onManualReteachPlate={onManualReteachClickHandler}
        />
      </div>
    );
    let rightPanel = null;

    switch (currentWizardView) {
      case 1:
        rightPanel = (
          <div className="right-panel" style={{height: `calc(100vh - ${isEdit ? '64' : '136'}px)`}}>
            <PlateViewInfoDesc
              plateTypeEditorState={plateTypeEditorState}
              onSetWellNumber={onSetWellNumber}
              onSetWellLabel={onSetWellLabel}
              onSetWellBottomProfile={onSetWellBottomProfile}
              onSetWellShape={onSetWellShape}
              onSetPlateName={onSetPlateName}
              onSetPartNumber={onSetPartNumber}
              onSetVendor={onSetVendor}
              onSetNotes={onSetNotes}
              onSetPlateType={onSetPlateType}
              isEdit={false}
              maxCharacters={labwareConfig.nameMaxLength}
              labwareBusinessIsLabwareNameAlreadyExist={labwareBusinessIsLabwareNameAlreadyExist}
              onSetColPitchAssaySample={onSetColPitchAssaySample}
              onSetColumnPitch={onSetColumnPitch}
              onSetRowPitch={onSetRowPitch}
            />
          </div>
        );
        break;
      case 2: {
        rightPanel = (
          <div className="right-panel" style={{height: `calc(100vh - ${isEdit ? '64' : '136'}px)`}}>
            <PlateViewMotionControl
              handleClickProceed={plateTypeEditorProceedMeasurement}
              plateTypeEditorState={plateTypeEditorState}
              onResetSafeProbe={plateTypeEditorBusinessResetProbePosition}
              errorHandler={onFastCommonActuatorAPIErrorHandler}
            />
          </div>
        );
        break;
      }
      case 3: {
        if (isPlateRecognitionEnabled) {
          rightPanel = plateRecognitionPanel;
        } else {
          rightPanel = summaryPanel;
        }
        break;
      }
      case 4:
        rightPanel = summaryPanel;
        break;
      default:
        rightPanel = null;
    }

    return rightPanel;
  }

  function validateDataPerStep() {
    const {
      currentWizardView,
      plateName,
      height,
      depth,
      width,
      length,
      columnOrigin,
      rowOrigin,
      capacity,
      workingVolume,
      wellNumber,
    } = plateTypeEditorState;

    if (currentWizardView === 1) {
      if (plateName && plateName.trim().length > 0 && wellNumber) {
        return !labwareBusinessIsLabwareNameAlreadyExist(plateName);
      }
    }

    if (currentWizardView === 2) {
      return (
        !(!height || height <= 0) &&
        !(!depth || depth <= 0) &&
        !(!width || width <= 0) &&
        !(!length || length <= 0) &&
        !(!columnOrigin || columnOrigin <= 0) &&
        !(!rowOrigin || rowOrigin <= 0)
      );
    }

    if (isPlateRecognitionEnabled) {
      if (currentWizardView === 3) {
        if (isEdit) {
          return isPlateEditStateChanged && isAllPlatesScanned;
        }
        return isAllPlatesScanned;
      }
      if (currentWizardView === 4) {
        return !(!capacity || capacity <= 0) && !(!workingVolume || workingVolume <= 0) && capacity >= workingVolume;
      }
    } else if (currentWizardView === 3) {
      return !(!capacity || capacity <= 0) && !(!workingVolume || workingVolume <= 0) && capacity >= workingVolume;
    }

    return false;
  }

  const disableEditSaveChanges = () => {
    if (isEdit && isPlateRecognitionEnabled && currentWizardView === 3 && isPlateEditStateChanged) return false;

    if (!isEditAllowed) return true;
    const {wellNumber, height, depth, width, length, columnOrigin, rowOrigin, columnPitch, rowPitch, plateName} =
      plateTypeEditorState;

    const obj = {height, depth, width, length, columnOrigin, rowOrigin, columnPitch, rowPitch};

    if (isEdit) {
      const isLabwareDefinitionUpdated = dispatch(isPlateEditorUpdated());
      if (!isLabwareDefinitionUpdated) {
        return true;
      }
    }

    if (!plateName) {
      return true;
    }

    if (plateName && plateName.trim().length > 0) {
      return labwareBusinessIsLabwareNameAlreadyExist(plateName, id);
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(obj)) {
      // eslint-disable-next-line no-restricted-globals
      if (parseFloat(obj[key]) === 0 || obj[key] === '' || isNaN(obj[key])) {
        if (
          (wellNumber !== WellCount.WELL_1 &&
            wellNumber !== WellCount.WELL_8 &&
            wellNumber !== WellCount.WELL_12 &&
            key === 'width') ||
          (wellNumber === WellCount.WELL_1 && (key === 'columnPitch' || key === 'rowPitch')) ||
          (wellNumber === WellCount.WELL_8 && key === 'columnPitch') ||
          (wellNumber === WellCount.WELL_12 && key === 'rowPitch')
        ) {
          continue;
        }

        return true;
      }
    }

    return false;
  };

  const {currentWizardView, processedStep, editMode, isEjectedTray} = plateTypeEditorState;

  const leftPanel = createLeftPanel(currentWizardView);
  const centerPanel = createCenterPanel(currentWizardView);
  const rightPanel = createRightPanel(currentWizardView);

  function handleClickStep(targetStep) {
    const processedStepNumber = isEdit ? 3 : processedStep;

    if (targetStep - 1 <= processedStepNumber) {
      if (editMode) {
        showDiscardChangeModal(targetStep);
      } else {
        if (currentWizardView !== targetStep) setIsError(false);
        onSetCurrentWizardView(targetStep);
      }
    }
  }

  const handleFinishReteachPlate = async () => {
    if (isManualReteachPage) {
      dispatch(showModalType(ModalType.RETURN_TIPS_CONFIRMATION, {saveChanges: true}));
      return;
    }
    await plateTypeEditorBusinessShowCleanupDialog(null, true, () => {
      removeUpdatedPlateFromReteachPlateList(plateTypeEditorState.id);
      onShowSnackbar(
        Feedback.SUCCESS,
        intl.formatMessage({id: 'plateTypeEditorContainer.reteachPlate.notification.success'}),
      );
    });
    plateTypeEditorBusinessCalculateWellCapacityAndWorkingVolume();
  };

  const handleCancelReteachPlate = () => {
    handleClickCancel(true);
  };

  const handleConfirmModalPreparation = () => {
    const {plateType, labwareID = id} = plateTypeEditorState;
    const {deckNumber} = manualReteachPlate;
    const {row, col, rowTipCount, colTipCount, labwareIndex} = generateRowColTipCount(selectedWellStyle);
    const groupIndex = plateType === PlateType.IFC ? labwareIndex : 0;
    const alphabethRow = convertRowToAlphabet(row);

    batch(() => {
      dispatch(
        showLoading(
          intl.formatMessage({id: 'plateTypeEditorContainer.manualReteachPlate.modalPreparation.Confirm.loading'}),
        ),
      );
      dispatch(saveState(false));
      dispatch(
        modalPreparationManualReteachPlateConfirmation(
          username,
          labwareID,
          deckNumber,
          colTipCount,
          rowTipCount,
          alphabethRow,
          col,
          groupIndex,
          false,
        ),
      );
    });

    setModalPreparationManualPlateShown(false);
  };

  const handleCloseManualReteachModalPreparation = () => {
    setModalPreparationManualPlateShown(false);
    dispatch(clearInstrumentProcess());
  };

  const getPanelContent = () => {
    if (isManualReteachPage) {
      return <ManualPlateTypeEditor selectedWellStyle={selectedWellStyle} />;
    }

    return (
      <>
        {leftPanel}
        {centerPanel}
        {rightPanel}
      </>
    );
  };

  const stepsLabel = isPlateRecognitionEnabled
    ? [
        intl.formatMessage({id: 'plateTypeEditorContainer.stepper.label.information'}),
        intl.formatMessage({id: 'plateTypeEditorContainer.stepper.label.measurement'}),
        intl.formatMessage({id: 'plateTypeEditorContainer.stepper.label.plateRecognition'}),
        intl.formatMessage({id: 'plateTypeEditorContainer.stepper.label.summary'}),
      ]
    : [
        intl.formatMessage({id: 'plateTypeEditorContainer.stepper.label.information'}),
        intl.formatMessage({id: 'plateTypeEditorContainer.stepper.label.measurement'}),
        intl.formatMessage({id: 'plateTypeEditorContainer.stepper.label.summary'}),
      ];

  return (
    <PageLayout>
      <PageLayout.Header>
        <PlateTypeEditorHeader
          currentWizardView={currentWizardView}
          isAllowedToNext={validateDataPerStep()}
          handleClickNext={isEdit ? handleEditSaveChanges : plateTypeEditorBusinessHandleClickNext}
          handleClickCancel={handleClickCancel}
          handleClickBack={() => {
            setIsError(false);
            plateTypeEditorBusinessHandleClickBack(isManualReteachPage);
          }}
          handleClickEjectTray={handleClickEjectTrayButton}
          editModePlateProperties={editMode}
          isEjectedTray={isEjectedTray}
          setIsEjectedTray={plateTypeEditorStateActionSetPlateTypeEditorEjectTray}
          isEdit={isEdit}
          isManualReteachPlate={isManualReteachPage}
          disableEditSaveChanges={isManualReteachPage ? !isMoveMotionControl : disableEditSaveChanges()}
          isError={isError}
          onFinishReteachPlate={handleFinishReteachPlate}
          onCancelReteachPlate={handleCancelReteachPlate}
        />
      </PageLayout.Header>
      <PageLayout.Content>
        <table className="plate-type-editor-container">
          <tbody>
            {!isEdit && (
              <tr>
                <td className="content-header">
                  <div className="content-header-step">
                    <Stepper
                      currentWizardView={currentWizardView}
                      isAllowedToClick={validateDataPerStep() || isEdit}
                      onClickStep={handleClickStep}
                      isEdit={isEdit}
                      width={745}
                      numberOfLabels={stepsLabel.length}
                      offset={0}
                      wrapLabel
                      stepsLabel={stepsLabel}
                    />
                  </div>
                </td>
              </tr>
            )}
            <tr>
              <td className="main-content">{getPanelContent()}</td>
            </tr>
          </tbody>
        </table>
      </PageLayout.Content>
      {ModalPreparationManualPlateShown && (
        <ModalPreparationManualPlateTypeEditor
          showModal
          selectedWellStyle={selectedWellStyle}
          onConfirm={handleConfirmModalPreparation}
          onClose={handleCloseManualReteachModalPreparation}
        />
      )}
    </PageLayout>
  );
}

function mapStateToProps(state) {
  return {
    appState: state.appState,
    sessionState: state.sessionState,
    plateTypeEditorState: state.plateTypeEditorState,
    labwareConfig: state.configState.labwareConfig,
    manualReteachPlate: state.reteachPlateState.manualReteachPlate,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onShowLoading: bindActionCreators(showLoading, dispatch),
    onHideLoading: bindActionCreators(hideLoading, dispatch),
    onShowModal: bindActionCreators(showModal, dispatch),
    onHideModal: bindActionCreators(hideModal, dispatch),
    onSetCurrentWizardView: (currentWizardView) => dispatch(setCurrentWizardView(currentWizardView)),
    onDecrementCurrentWizardView: () => dispatch(decrementCurrentWizardView()),
    onSetAllowedToNext: (allowedToNext) => dispatch(setAllowedToNext(allowedToNext)),
    onSetProcessedStep: (processedStep) => dispatch(setProcessedStep(processedStep)),
    onSetWellNumber: (wellNumber) => dispatch(setWellNumber(wellNumber)),
    onSetWellLabel: (wellLabel) => dispatch(setWellLabel(wellLabel)),
    onSetWellBottomProfile: (wellBottomProfile) => dispatch(setWellBottomProfile(wellBottomProfile)),
    onSetWellShape: (wellShape) => dispatch(setWellShape(wellShape)),
    onSetPlateName: (plateName) => dispatch(setPlateName(plateName)),
    onSetPlateType: (plateType) => dispatch(setPlateType(plateType)),
    onSetColPitchAssaySample: (colPitchAssay) => dispatch(setColPitchAssaySample(colPitchAssay)),
    onSetTroughDepth: (troughDepth) => dispatch(setTroughDepth(troughDepth)),
    onSetPartNumber: (partNumber) => dispatch(setPartNumber(partNumber)),
    onSetVendor: (vendor) => dispatch(setVendor(vendor)),
    onSetNotes: (notes) => dispatch(setNotes(notes)),
    onSetHeight: (height) => dispatch(setHeight(height)),
    onSetDepth: (depth) => dispatch(setDepth(depth)),
    onSetWidth: (width) => dispatch(setWidth(width)),
    onSetLength: (length) => dispatch(setLength(length)),
    onSetColumnOrigin: (columnOrigin) => dispatch(setColumnOrigin(columnOrigin)),
    onSetRowOrigin: (rowOrigin) => dispatch(setRowOrigin(rowOrigin)),
    onSetColumnPitch: (columnPitch) => dispatch(setColumnPitch(columnPitch)),
    onSetRowPitch: (rowPitch) => dispatch(setRowPitch(rowPitch)),
    onSetCapacity: (capacity) => dispatch(setCapacity(capacity)),
    onSetWorkingVolume: (workingVolume) => dispatch(setWorkingVolume(workingVolume)),
    onSetLastProcessedId: (workingVolume) => dispatch(setLastProcessedId(workingVolume)),
    onFastCommonActuatorAPIErrorHandler: bindActionCreators(fastCommonActuatorAPIErrorHandler, dispatch),
    stateBusinessSaveState: bindActionCreators(saveState, dispatch),
    instrumentBusinessEjectTray: bindActionCreators(ejectTray, dispatch),
    instrumentBusinessSafeMoveVerticalCarrier: bindActionCreators(safeMoveVerticalCarrier, dispatch),
    plateTypeEditorBusinessResetProbePosition: bindActionCreators(handleResetProbePosition, dispatch),
    plateTypeEditorBusinessHandleClickBack: bindActionCreators(handleClickBack, dispatch),
    plateTypeEditorBusinessHandleClickNext: bindActionCreators(handleClickNext, dispatch),
    plateTypeEditorBusinessShowCleanupDialog: bindActionCreators(showCleanupDialog, dispatch),
    plateTypeEditorBusinessExitPlateTypeEditor: bindActionCreators(exitPlateTypeEditor, dispatch),
    plateTypeEditorBusinessCalculateWellCapacityAndWorkingVolume: bindActionCreators(
      calculateWellCapacityAndWorkingVolume,
      dispatch,
    ),
    plateTypeEditorStateActionSetPlateTypeEditorEjectTray: bindActionCreators(setPlateTypeEditorEjectTray, dispatch),
    plateTypeEditorStateActionSetPlateTypeEditorEditMode: bindActionCreators(setPlateTypeEditorEditMode, dispatch),
    labwareDatabaseBusinessUpdateLabwareDefinition: bindActionCreators(updateLabwareDefinition, dispatch),
    labwareDatabaseBusinessRefreshLabwareDefinitions: bindActionCreators(refreshLabwareDefinitions, dispatch),
    labwareBusinessIsLabwareNameAlreadyExist: bindActionCreators(isLabwareNameAlreadyExist, dispatch),
    plateTypeEditorProceedMeasurement: bindActionCreators(proceedMeasurement, dispatch),
    plateTypeEditorConvertPlateTypeEditorStateToJSON: bindActionCreators(converPlateTypeEditorStateToJSON, dispatch),
    removeUpdatedPlateFromReteachPlateList: bindActionCreators(removeUpdatedPlateFromReteachPlateState, dispatch),
    onShowSnackbar: bindActionCreators(showSnackbar, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(PlateTypeEditorContainer));

PlateTypeEditorContainer.propTypes = {
  plateTypeEditorState: PropTypes.any.isRequired,
  appState: PropTypes.any.isRequired,
  sessionState: PropTypes.any.isRequired,
  manualReteachPlate: PropTypes.any.isRequired,
  onSetCurrentWizardView: PropTypes.func.isRequired,
  onDecrementCurrentWizardView: PropTypes.func.isRequired,
  onSetAllowedToNext: PropTypes.func.isRequired,
  onSetProcessedStep: PropTypes.func.isRequired,
  onSetWellNumber: PropTypes.func.isRequired,
  onSetWellLabel: PropTypes.func.isRequired,
  onSetWellBottomProfile: PropTypes.func.isRequired,
  onSetWellShape: PropTypes.func.isRequired,
  onSetPlateName: PropTypes.func.isRequired,
  onSetPlateType: PropTypes.func.isRequired,
  onSetColPitchAssaySample: PropTypes.func.isRequired,
  onSetTroughDepth: PropTypes.func.isRequired,
  onSetPartNumber: PropTypes.func.isRequired,
  onSetVendor: PropTypes.func.isRequired,
  onSetNotes: PropTypes.func.isRequired,
  onSetHeight: PropTypes.func.isRequired,
  onSetDepth: PropTypes.func.isRequired,
  onSetWidth: PropTypes.func.isRequired,
  onSetLength: PropTypes.func.isRequired,
  onSetColumnOrigin: PropTypes.func.isRequired,
  onSetRowOrigin: PropTypes.func.isRequired,
  onSetColumnPitch: PropTypes.func.isRequired,
  onSetRowPitch: PropTypes.func.isRequired,
  onSetCapacity: PropTypes.func.isRequired,
  onSetWorkingVolume: PropTypes.func.isRequired,
  onSetLastProcessedId: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  onShowLoading: PropTypes.func.isRequired,
  onHideLoading: PropTypes.func.isRequired,
  onShowModal: PropTypes.func.isRequired,
  onHideModal: PropTypes.func.isRequired,
  onFastCommonActuatorAPIErrorHandler: PropTypes.func.isRequired,
  plateTypeEditorBusinessResetProbePosition: PropTypes.func.isRequired,
  plateTypeEditorBusinessHandleClickBack: PropTypes.func.isRequired,
  plateTypeEditorBusinessHandleClickNext: PropTypes.func.isRequired,
  plateTypeEditorBusinessShowCleanupDialog: PropTypes.func.isRequired,
  plateTypeEditorBusinessExitPlateTypeEditor: PropTypes.func.isRequired,
  plateTypeEditorBusinessCalculateWellCapacityAndWorkingVolume: PropTypes.func.isRequired,
  plateTypeEditorStateActionSetPlateTypeEditorEjectTray: PropTypes.func.isRequired,
  plateTypeEditorStateActionSetPlateTypeEditorEditMode: PropTypes.func.isRequired,
  stateBusinessSaveState: PropTypes.func.isRequired,
  instrumentBusinessEjectTray: PropTypes.func.isRequired,
  instrumentBusinessSafeMoveVerticalCarrier: PropTypes.func.isRequired,
  labwareBusinessIsLabwareNameAlreadyExist: PropTypes.func.isRequired,
  labwareDatabaseBusinessUpdateLabwareDefinition: PropTypes.func.isRequired,
  labwareDatabaseBusinessRefreshLabwareDefinitions: PropTypes.func.isRequired,
  labwareConfig: PropTypes.object.isRequired,
  plateTypeEditorProceedMeasurement: PropTypes.func.isRequired,
  plateTypeEditorConvertPlateTypeEditorStateToJSON: PropTypes.func.isRequired,
  removeUpdatedPlateFromReteachPlateList: PropTypes.func.isRequired,
  onShowSnackbar: PropTypes.func.isRequired,
};
